import * as React from "react";
// import { styled } from "@mui/system";
// import MUIBox, { BoxProps as BoxPropsMUI } from "@mui/material/Box";

import { BoxTypeMap } from "@mui/system";
import { OverridableComponent } from "@mui/types";
import { Theme as MaterialTheme } from "@mui/material/styles";
import MUIBox from "@mui/material/Box";
import { BoxProps as BoxPropsMUI } from "@mui/material/Box";
export interface BoxProps extends BoxPropsMUI {}

export const Box: OverridableComponent<BoxTypeMap<{}, "div", MaterialTheme>> =
  MUIBox;

// export interface BoxProps extends BoxPropsMUI {
//   component?: React.ElementType &
//     React.ElementType<BoxTypeMap["defaultComponent"]>;
// }

// export const Box: (props: BoxProps) => JSX.Element = styled(
//   React.forwardRef<HTMLElement, BoxProps & React.RefAttributes<HTMLElement>>(
//     (props, ref) => <MUIBox {...props} ref={ref} />
//   ),
//   {
//     name: "Box",
//     slot: "Root",
//     overridesResolver: (props, styles) => []
//   }
// )(({ theme }) => ({}));
